var map = {
	"./business.svg": 383,
	"./charity-event.svg": 384,
	"./culinary-art.svg": 385,
	"./culture.svg": 386,
	"./eco.svg": 387,
	"./education.svg": 388,
	"./for-kids.svg": 389,
	"./games.svg": 390,
	"./leisure.svg": 391,
	"./music.svg": 392,
	"./others.svg": 393,
	"./sport.svg": 394,
	"./travel.svg": 395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 382;